import React from 'react';
import styled from 'react-emotion';
import Player from './Player';
import './Colors.css';
import { DrawMode } from './Model';
import './Frenzy.css';

const ScoreboardSection = styled('section')`
	margin: 4px 8px;
`;

const H1 = styled('h1')`
	margin: 8px auto;	
`;

const Boxed = styled(H1)`
	border: 2px solid #fff;
	padding: 0;

	& div {
		margin: 10px 8px 8px 8px;
	}
`;


type Props = {
	score: number;
	lives: number;
	drawMode: DrawMode;
	bonusMultiplier: number;
	counterValue: number;
	scale: number;
} 

class Scoreboard extends React.PureComponent<Props> {


	render() {
		const {score, lives, drawMode, bonusMultiplier, counterValue, scale} = this.props;
		let drawModeToString;
		switch(drawMode) {		
			case 1: drawModeToString = 'Slow'; break;
			case 2: drawModeToString = 'Fast'; break;
			default: drawModeToString = '';
		}

		return (
			<div className="Scoreboard">
				<ScoreboardSection key={`score-${score}${drawModeToString}`}>
					<H1>Score</H1>
					<Boxed>
						<div data-testid="score">{score.toString().padStart(6, "0")}</div>
					</Boxed>
					<H1 data-testid="draw-mode">{drawModeToString}</H1>
				</ScoreboardSection>
				<ScoreboardSection key={`lives-${lives}`}>
					<H1>Lives</H1>
					<div className="LifeBoxContainer">
					{[...Array(lives)].map((e, i) => 
						<Player testID="life" key={`life-${i}`} moveable={false} scale={scale} />
					)}
					</div>
				</ScoreboardSection>
				<ScoreboardSection key={`bonus-${bonusMultiplier}-${counterValue}`}>
					<H1>Bonus</H1>
					<Boxed>
						<div data-testid="bonus">x{bonusMultiplier.toString().padStart(2, "0")}</div>
						<hr />
						<div data-testid="counter">+{counterValue.toString().padStart(4, "0")}</div>
					</Boxed>
				</ScoreboardSection>
			</div>
		);
	}
}

export default Scoreboard;
